import AppSvgIconNew from './AppSvgIcon.vue';
export default AppSvgIconNew;



// WEBPACK FOOTER //
// ./src/uikit/components/AppSvgIconNew/index.ts